import Vue from 'vue';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'DmsSms',
  props: {
    displayDialog: {
      type: Boolean,
      required: true,
    },
    dataObj: {
      type: Object,
      required: true
      }
    },
  data: function () {
    return {
      displayAdHocSmsDialoc: false,
      finalText: ''
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    sendSmsFunc() {
    },
    adHocSmsDialogOpen() {
      this.displayAdHocSmsDialoc = true;
    },
    sendSpotBillSms() {
      let parameter = {
        CaseId: this.dataObj.caseId,
        Custkey: this.dataObj.account,
      };

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmCase/SendSms', parameter)
        .then(response => {
          if (response.status != 200)
            this.$alertMsg(response.data.text);

          loader.hide();
        })
        .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
        .finally(() => this.closeDialog());
    },
    closeDialog() {
      this.displayAdHocSmsDialoc = false;
      this.$root.$emit('close_dms_send_sms_dialog');
      this.$emit('close');
    },
  },

}
